<template>
  <section class="results">
    <div class="container container-md">
      <div class="row">
        <result-card v-for="result in currentResults" :provider='result'/>
      </div>
    </div>
    <infinite-loading
      v-if="!loadingResults && !noneSelected()"
      @infinite="loadMore"
      spinner="spiral"
    >
      <div slot="no-more">No more results</div>
    </infinite-loading>
  </section>
</template>

<script>

import ResultCard from './ResultCard.vue'
import InfiniteLoading from "vue-infinite-loading";
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'results',
  components: {
    'result-card': ResultCard,
    'infinite-loading': InfiniteLoading
  },
  computed: {
    ...mapGetters([
      "results",
      "currentResults",
      "isFirstSearch",
      "fundingNeed",
      "timeTaken",
      "noResults",
      "getNumResults",
      "loadingResults"
    ]),
  },
  mounted(){
    this.resetRange()
  },
  methods: {
    ...mapMutations([
      "appendResults",
      "resetRange"
    ]),
    noneSelected(){
      return this.$store.state.cfStore.searchResults.countriesParam.length == 0
        && this.$store.state.cfStore.searchResults.sectorsParam.length == 0
        && this.$store.state.cfStore.searchResults.providerTypesParam.length == 0
        && this.$store.state.cfStore.searchResults.capitalTypesParam.length == 0
    },
    loadMore: function($state) {
      // this.loadingMore = true;
      var vm = this
      setTimeout(() => {
        vm.appendResults();
        if (vm.currentResults.length>=vm.getNumResults) {
          $state.complete();
        }
        // this.loadingMore = false;
        $state.loaded();
      }, 700);
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/elements/results/Results.vue